/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/broken_chain_medium'
export default icon
